import DownGraphIcon from './down-graph.svg';
import UpGraphIcon from './up-graph.svg';

export { DownGraphIcon, UpGraphIcon };
